import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const directStandardTypesAdapter = getAdapter({ idFieldName: 'value' });

const directStandardTypesSlice = createSlice({
  name: 'directStandardTypes',
  initialState: directStandardTypesAdapter.getInitialState(),
  reducers: {
    setDirectStandardTypes: (state, { payload: { directStandardTypes } }) => {
      directStandardTypesAdapter.setAll(state, directStandardTypes);
    },
  },
});

const selectors = directStandardTypesAdapter.getSelectors(({ directStandardTypes }) => directStandardTypes);

export const getAlldirectStandardTypes = (state) => selectors.selectAll(state);

export const getDirectStandardTypes = (state) => getAlldirectStandardTypes(state)
  .filter(({ deleted }) => !deleted);

export const {
  setDirectStandardTypes,
} = directStandardTypesSlice.actions;

export default directStandardTypesSlice.reducer;
